export default __webpack_public_path__ + "static/media/casterly_rock.6b6d5113.jpg";